import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AppIcon } from '../app-icon/app-icon';

type AuthButtonType = 'primary' | 'secondary' | 'danger' | 'text';
type AuthButtonSize = 'sm' | 'md' | 'lg';
type NativeButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-button',
  imports: [AppIcon],
  templateUrl: './app-button.html',
  styleUrl: './app-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.button-host-full-width]': 'fullWidth()',
  },
})
export class ButtonComponent {
  readonly buttonType = input<AuthButtonType>('primary');
  readonly size = input<AuthButtonSize>('md');
  readonly nativeType = input<NativeButtonType>('button');
  readonly disabled = input(false);
  readonly loading = input<boolean, unknown>(false, { transform: booleanAttribute });

  readonly preIcon = input<string | null>(null);
  readonly postIcon = input<string | null>(null);
  readonly iconColor = input<string | null>(null);
  readonly iconWidth = input(20);
  readonly iconHeight = input(20);
  readonly fontColor = input<string | null>(null);
  readonly fontSize = input<string | null>(null);
  readonly fullWidth = input<boolean, unknown>(false, { transform: booleanAttribute });
  readonly horizontalPadding = input<boolean, unknown>(false, { transform: booleanAttribute });
  readonly pressed = output<void>();

  protected emitPressed(): void {
    this.pressed.emit();
  }
}
